import axios from 'axios'


axios.get('/ajax/coockie.php', {})
    .then(function (response) {
      var e = document.createElement('div');
      e.innerHTML = response.data;
      document.querySelector('body').append(e)

      console.log(document.querySelector('.js-cookie-close'))
      if (document.querySelector('.js-cookie-close')) {
        document.querySelector('.js-cookie-close').addEventListener('click', function() {
          let data

          this.parentElement.classList.add('close')
          data = new FormData()
          data.append('setCookie', true)
          axios({
            method: 'post',
            data: data,
            url: '/ajax/coockie.php',
          });
        })
      }
    });
